import { AccountResponse } from "./../../services/accounts";

export enum AccountType {
  PERSONAL = 1,
  JOINT = 2,
}

export const ACCOUNT_TYPE_LABEL = {
  [AccountType.PERSONAL]: "Personal",
  [AccountType.JOINT]: "Joint",
};

export enum Plan {
  FREE = 1,
  PREMIUM = 2,
}

export const PLAN_LABEL = {
  [Plan.FREE]: "Free",
  [Plan.PREMIUM]: "Premium",
};

export const PLAN_INTEREST = {
  [Plan.FREE]: 1,
  [Plan.PREMIUM]: 3,
};

export class Account {
  id: string;
  plan: Plan;
  type: AccountType;
  nickname: string;
  age: number;
  birthdate: string;
  balance: number;
  yearlyBreakdown: { age: number; year: number; amount: number }[];

  constructor({
    id,
    plan,
    type,
    nickname,
    age,
    birthdate,
    balance,
    yearlyBreakdown,
  }: AccountResponse) {
    this.id = id;
    this.plan = plan;
    this.type = type;
    this.age = age;
    this.nickname = nickname;
    this.birthdate = birthdate;
    this.balance = balance;
    this.yearlyBreakdown = yearlyBreakdown;
  }
}
